import {Component, HostListener, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  templateUrl: 'image-viewer.component.html',
  selector: 'unr-image-viewer',
  styleUrls: [
    'image-viewer.component.scss'
  ]
})
export class UnrImageViewer {
  @Input() imageUrl: string;

  constructor(private modalCtrl: ModalController) {
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }

  @HostListener('click')
  onClick() {
    this.modalCtrl.dismiss();
  }
}
